import {
  BrandConfig,
  BrandFeaturesConfig,
  defaultBrandConfig,
  defaultBrandFeaturesConfig,
  defaultCurrency,
  defaultEnvConfig,
  defaultLocale,
  EnvConfig,
} from 'src/configurations'
import { ExtendCurrency, ExtendLocales } from 'src/enums'
import {
  RemoteConfigModel,
  RemoteConfigResponse,
} from 'src/models/remoteConfig.models'
import FeatureFlaggerReducer, {
  Actions as FeatureFlaggerActions,
} from 'src/redux/reducers/data/featureFlagger.reducer'
import RemoteConfigReducer, {
  Actions as RemoteConfigActions,
} from 'src/redux/reducers/data/remoteConfig.reducer'

export interface SessionState {
  brandConfig: BrandConfig
  brandFeaturesConfig: BrandFeaturesConfig
  envConfig: EnvConfig
  defaultLocale: ExtendLocales
  defaultCurrency: ExtendCurrency
  remoteConfig: RemoteConfigModel
  featureFlagger: Partial<RemoteConfigResponse>
}

export const initialState: SessionState = {
  brandConfig: defaultBrandConfig,
  brandFeaturesConfig: defaultBrandFeaturesConfig,
  envConfig: defaultEnvConfig,
  defaultCurrency: defaultCurrency,
  defaultLocale: defaultLocale,
  remoteConfig: RemoteConfigModel.defaultConfig(),
  featureFlagger: {},
}
export type Actions = RemoteConfigActions | FeatureFlaggerActions

const SessionReducer = (
  state: SessionState = initialState,
  action: Actions,
): SessionState => {
  return {
    ...state,
    remoteConfig: RemoteConfigReducer(
      state.remoteConfig,
      action as RemoteConfigActions,
    ),
    featureFlagger: FeatureFlaggerReducer(
      state.featureFlagger,
      action as FeatureFlaggerActions,
    ),
  }
}

export default SessionReducer
